import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckItem } from './CheckItem';
type VolumeCardProps = {
  number: string;
  title: string;
  text: string;
  includes: string[];
};
export function VolumeCard({
  number,
  title,
  text,
  includes
}: VolumeCardProps) {
  return <article className="flex flex-col overflow-hidden rounded-md border border-slate-200 bg-white" data-id="element-172" data-mp="y35estfjs5gr">
      <div className="flex items-start gap-2 bg-blue-950 px-3 py-2" data-id="element-173" data-mp="1ut4vjb5uqaaf">
        <span className="mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] bg-green-600" aria-hidden data-id="element-174" data-mp="1uvinhb58j6dr">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-175" data-mp="1l3lapzykw6cx" />
        </span>
        <h3 className="text-[13px] font-extrabold uppercase leading-tight text-white md:text-[14px]" data-id="element-176" data-mp="1l18k6yer8no9">
          Volumen {number} — {title}
        </h3>
      </div>
      <div className="flex flex-1 flex-col px-3 py-2.5 md:px-3.5 md:py-3" data-id="element-177" data-mp="2dkp9p858mg4b">
        <p className="text-[14px] leading-[1.4] text-slate-600" data-id="element-178" data-mp="28sxh6s2iu0bj">{text}</p>
        <p className="mt-2 text-[12px] font-extrabold uppercase text-blue-950" data-id="element-179" data-mp="37c0k2o0cg5qr">Vas a encontrar:</p>
        <ul className="mt-1 grid gap-x-4 gap-y-0.5 sm:grid-cols-2 text-[13px] leading-[1.4] text-slate-600 md:text-[14px]" data-id="element-180" data-mp="3cb3pwao5efzs">
          {includes.map(item => <CheckItem key={item} data-id="element-181" data-mp="2xlxiw0j2jlhc">{item}</CheckItem>)}
        </ul>
        <p className="mt-auto pt-2.5 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-182" data-mp="32k8w8l8koe4b">
          40 páginas de recursos visuales.
        </p>
      </div>
    </article>;
}